(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 93269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(16202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77297);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);




var Layout = function(param) {
    var children = param.children, categories = param.categories, seo = param.seo;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                flexGrow: 1,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 37636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pK": function() { return /* binding */ getStrapiURL; },
/* harmony export */   "nV": function() { return /* binding */ getIskibrisUrl; },
/* harmony export */   "cD": function() { return /* binding */ fetchEmployersAPI; }
/* harmony export */ });
/* unused harmony export fetchAPI */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function getStrapiURL() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat("https://strapi.iskibris.com" || 0).concat(path);
}
function getIskibrisUrl() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat("https://api.iskibris.com" || 0).concat(path);
}
// Helper to make GET requests to Strapi
function fetchAPI(path) {
    return _fetchAPI.apply(this, arguments);
}
function _fetchAPI() {
    _fetchAPI = _asyncToGenerator(regeneratorRuntime.mark(function _callee(path) {
        var requestUrl, response, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requestUrl = getStrapiURL(path);
                    _ctx.next = 3;
                    return fetch(encodeURI(requestUrl));
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAPI.apply(this, arguments);
}
function fetchEmployersAPI(path) {
    return _fetchEmployersAPI.apply(this, arguments);
}
function _fetchEmployersAPI() {
    _fetchEmployersAPI = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(path) {
        var requestUrl, response, data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requestUrl = getIskibrisUrl(path);
                    _ctx.next = 3;
                    return fetch(encodeURI(requestUrl));
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchEmployersAPI.apply(this, arguments);
}


/***/ }),

/***/ 16202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(46737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./src/components/layout.js
var layout = __webpack_require__(32283);
// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(37636);
// EXTERNAL MODULE: ./node_modules/react-whatsapp-widget/dist/index.css
var dist = __webpack_require__(80138);
// EXTERNAL MODULE: ./node_modules/react-whatsapp-widget/dist/index.modern.js
var index_modern = __webpack_require__(39728);
;// CONCATENATED MODULE: ./src/components/WhatsappContact/index.jsx



var WhatsappContact = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
        phoneNumber: "905428570360",
        message: "Merhaba, nasıl yardımcı olabilirim?",
        textReplyTime: "Genellikle bir saat i\xe7inde yanıt verir.",
        companyName: "İş Kıbrıs Destek",
        sendButton: "G\xf6nder"
    }));
};
/* harmony default export */ var components_WhatsappContact = (WhatsappContact);

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 28 modules
var TextField = __webpack_require__(88204);
// EXTERNAL MODULE: ./node_modules/@mui/base/TextareaAutosize/TextareaAutosize.js
var TextareaAutosize = __webpack_require__(37598);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/pages/contact.js








var Contact = function() {
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(""), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), message = ref3[0], setMessage = ref3[1];
    var url = (0,api/* getIskibrisUrl */.nV)("/api/contact");
    var handleSubmit = function(event) {
        event.preventDefault();
        var messageForm = {
            full_name: name,
            email: email,
            phone_number: phoneNumber,
            message: message
        };
        axios_default().post(url, messageForm).then(function(res) {
            sweetalert_min_default()("Teşekk\xfcrler!", "Mesajınız iletilmiştir.", "success");
            setName("");
            setPhoneNumber("");
            setEmail("");
            setMessage("");
        }).catch(function(error) {
            sweetalert_min_default()("Dikkat", error.message, "warning");
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section section--bg-world",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "İletişim"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row__medium-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "headline",
                                        children: [
                                            "Sosyal Medyadan da ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "bize ulaşabilirsiniz."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Sadece 1-2 saat i\xe7inde bilgi/destek talebinize d\xf6nm\xfcş olacağız"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row__medium-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "form-dww",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row__paddingTop",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    id: "name",
                                                    type: "text",
                                                    style: {
                                                        width: "40%"
                                                    },
                                                    label: "Ad Soyad",
                                                    variant: "outlined",
                                                    name: "name",
                                                    value: name,
                                                    size: "small",
                                                    onChange: function(e) {
                                                        return setName(e.target.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row__paddingTop",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    id: "phone_number",
                                                    label: "Telefon Numaranız",
                                                    variant: "outlined",
                                                    type: "text",
                                                    name: "phone_number",
                                                    size: "small",
                                                    value: phoneNumber,
                                                    style: {
                                                        width: "40%"
                                                    },
                                                    onChange: function(e) {
                                                        return setPhoneNumber(e.target.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row__paddingTop",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    id: "email",
                                                    variant: "outlined",
                                                    style: {
                                                        width: "40%"
                                                    },
                                                    label: "Email",
                                                    type: "text",
                                                    name: "email",
                                                    value: email,
                                                    size: "small",
                                                    onChange: function(e) {
                                                        return setEmail(e.target.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row__paddingTop",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaAutosize/* default */.Z, {
                                                    type: "text",
                                                    placeholder: "Nasıl yardımcı olabiliriz?",
                                                    name: "message",
                                                    id: "",
                                                    minRows: 10,
                                                    style: {
                                                        width: "40%"
                                                    },
                                                    value: message,
                                                    onChange: function(e) {
                                                        return setMessage(e.target.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "submit",
                                                className: "form__submit",
                                                style: {
                                                    width: "40%",
                                                    textTransform: "none",
                                                    fontSize: "1em"
                                                },
                                                size: "small",
                                                value: "G\xf6nder",
                                                children: "G\xf6nder"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WhatsappContact, {})
        ]
    }));
};
/* harmony default export */ var contact = (Contact);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,874,617,160,191,795,774,888,179], function() { return __webpack_exec__(93269); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);